import React from 'react';

const contextTypes = {
  store: React.PropTypes.object.isRequired,
};

export default function connect(Component) {
  class Connect extends React.Component {
    constructor(props, context) {
      super(props);
      this.state = {
        storeState: context.store.getState(),
      };
      this.handleUpdate = this.handleUpdate.bind(this);
    }

    componentDidMount() {
      this.context.store.subscribe(this.handleUpdate);
    }

    handleUpdate(storeState) {
      this.setState((state, props) => {
        return {
          storeState,
        };
      })
    }

    render() {
      return <Component
        getMoreMessages={this.context.store.getMoreMessages}
        deleteMessage={this.context.store.deleteMessage}
        messages={this.state.storeState.messages}
        loading={this.state.storeState.loading}
        {...this.props}
      />;
    }
  };

  Connect.displayName = `Connect${Component.name}`;
  Connect.contextTypes = contextTypes;

  return Connect;
}



// WEBPACK FOOTER //
// ./src/messageStore/connect.js